import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-products-redorder',
  templateUrl: './products-redorder.component.html',
  styleUrls: ['./products-redorder.component.scss']
})
export class ProductsRedorderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
